import * as React from "react";

const LinkIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} {...props}>
    <path d="M2.222 20a2.14 2.14 0 0 1-1.569-.653A2.14 2.14 0 0 1 0 17.778V2.222A2.14 2.14 0 0 1 .653.653 2.14 2.14 0 0 1 2.222 0H10v2.222H2.222v15.556h15.556V10H20v7.778a2.14 2.14 0 0 1-.653 1.569 2.14 2.14 0 0 1-1.569.653Zm5.222-5.889-1.556-1.556L16.221 2.222h-4V0H20v7.778h-2.222v-4Z" />
  </svg>
);

export default LinkIcon;